module.exports = __webpack_public_path__ + "img/77.4b1b0543.png";